import { useInvoiceQuery } from '../graphql'

export default function useInvoiceDetails( id: number ) {
	const { data, loading } = useInvoiceQuery( { variables: { id } } )
	const orderedBy = data?.invoice?.ordered_by_user ? `${data.invoice.ordered_by_user.first_name} ${data.invoice.ordered_by_user.last_name}` : ''

	return {
		loading,
		orderedBy,
		invoiceNo: data?.invoice?.invoice_no,
	}
}
